import React from 'react';
import PropTypes from 'prop-types';
import {Grid, Container, Box, Heading, Link} from '@tenancy.nz/ui';
import {DEFAULT_404_IMG} from '../utils/constants';

function DeletedProperty({url = null}) {
  return (
    <Container maxWidth="md">
      <Box
        sx={{
          p: 5,
        }}>
        <Grid container alignItems="center">
          <Grid item xs={12} md={7}>
            <Box
              sx={{
                py: 5,
              }}>
              <Heading as="h4" style={{lineHeight: 1.4}} align="center">
                The property has been removed from consideration. We encourage
                you to submit a booking for an alternative property.
              </Heading>
              <Heading as="h4" style={{lineHeight: 1.4}} align="center">
                Click{' '}
                <Link
                  href={url}
                  color="inherit"
                  target="_blank"
                  underline="always">
                  <strong>here</strong>
                </Link>{' '}
                to explore other available properties.
              </Heading>
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                py: 5,
              }}>
              <Box
                sx={{
                  width: '60%',
                  maxWidth: 250,
                  display: 'block',
                  height: 'auto',
                  margin: '0 auto',
                  '> img': {
                    maxWidth: '100%',
                  },
                }}>
                <img alt="" src={DEFAULT_404_IMG} />
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

DeletedProperty.propTypes = {
  url: PropTypes.string,
};

export default DeletedProperty;
